var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:{
            'loading-placeholder': true,
            'text-placeholder': true,
        },style:({
            backgroundColor: _vm.color,
            opacity: _vm.opacity,
            height: _vm.height
        })},[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }